module.exports = __webpack_public_path__ + "media/images/bi_logo-2b17953b.svg";